import apiClient from "../../utils/api.client";
import { setCouponsErrors } from "../../store/slices/errors";
import { getNoaId, getOrganizationId } from "../../utils/session.utils";

// NOTE: Ask whether the organization id is needed or not
const getAllCupons = async () => {
  // return fetch(`/delivery-service/coupon?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/coupon?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllCupons EP: ", error);
    throw error;
  }
};

const getCuponsByGame = async (gameid, draw) => {
  // return fetch(`${getServiceUrl()}/coupon/getgame/nrolottery?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId&idgame=${gameid}${draw ? `&nrolottery=${draw}` : ''}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/coupon/getgame/nrolottery?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId&idgame=${gameid}${draw ? `&nrolottery=${draw}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getCuponsByGame EP: ", error);
    throw error;
  }
};

const getPackagesByGame = async (gameid, serie) => {
  // return fetch(`${getServiceUrl()}/coupon/getgame/serie?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId&gameId=${gameid}${serie ? `&raffleId=${serie}` : ''}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    const url = `/delivery-service/coupon/getgame/serie?pageNumber=1&pageSize=20&orderCriteria=DESC&orderField=gameId&gameId=${gameid}${serie ? `&raffleId=${serie}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPackagesByGame EP: ", error);
    throw error;
  }
};

const getItemsByGameSerie = async (pageNumber, pageSize, dispatch, gameId) => {
  // return fetch(`${getServiceUrl()}/coupon/itemsbygamesorteo?pageNumber=${pageNumber || 1}&pageSize=${pageSize || 10}&orderCriteria=ASC&orderField=gameId&gameId=${gameId}`, {
  //   method: "GET",
  //   headers: { "Content-Type": "application/json", "accept": "application/json" }
  // })
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    const url = `/delivery-service/coupon/itemsbygamesorteo?pageNumber=${pageNumber || 1}&pageSize=${pageSize || 10}&orderCriteria=ASC&orderField=gameId&gameId=${gameId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getItemsByGameSerie EP: ", error);
    throw error;
  }
};

const getMovements = async (pageNumber, pageSize, idGame, raffleId) => {
  // return fetch(`${getServiceUrl()}/coupon/movement/getgame/sorteo?pageNumber=${pageNumber || 1}&pageSize=${pageSize || 10}&orderCriteria=DESC&orderField=createDate&idgame=${idGame}&raffleId=${raffleId || ''}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  try {
    const url = `/delivery-service/coupon/movement/getgame/sorteo?pageNumber=${pageNumber || 1}&pageSize=${pageSize || 10}&orderCriteria=DESC&orderField=createDate&idgame=${idGame}&raffleId=${raffleId || ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getMovements EP: ", error);
    throw error;
  }
};

const getStockByGame = async (
  pageNumber,
  pageSize,
  orderCriteria,
  orderField,
  gameId,
) => {
  // return fetch(`${getServiceUrl()}/coupon/movement/getgame/lottery?pageNumber=${pageNumber || "1"}&pageSize=${pageSize || "10"}&orderCriteria=${orderCriteria || "ASC"}&orderField=${orderField || "raffleId"}&gameId=${gameId}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  try {
    const url = `/delivery-service/coupon/movement/getgame/lottery?pageNumber=${pageNumber || "1"}&pageSize=${pageSize || "10"}&orderCriteria=${orderCriteria || "ASC"}&orderField=${orderField || "raffleId"}&gameId=${gameId}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at etMovements E EP: ", error);
    throw error;
  }
};

const getLotteryStockItems = async (
  page,
  pageSize,
  sort,
  status,
) => {
  // const { criteria, field } = sort;
  // return fetch(`${getServiceUrl()}/coupon/lotteryitems?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'gameId'}&organizationId=${organizationId}${status === 'none' ? '' : `&enabled=${status}`}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })
  const { criteria, field } = sort;
  try {
    const noaId = getNoaId();
    const url = `/delivery-service/coupon/lotteryitems?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "gameId"}&organizationId=${noaId}${status === "none" ? "" : `&enabled=${status}`}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getLotteryStockItems EP: ", error);
    throw error;
  }
};

const getSuppliersByStockItem = async (
  page,
  pageSize,
  raffleId,
  filters,
  sort,
) => {
  // const { criteria, field } = sort;
  // return fetch(`${getServiceUrl()}/coupon/suppliers?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'ASC'}&orderField=${field || 'businessName'}&enabled=true${raffleId ? `&raffleId=${raffleId}` : ''}${filters.razonSocial ? `&razonSocial=${filters.razonSocial}` : ''}`)
  //   .then(res => {
  //     if (res.status === 200) {
  //       return res.json();
  //     } else {
  //       throw { res, isServiceException: true }
  //     }
  //   })
  //   .catch(async (e) => {
  //     if (!e.isServiceException) {
  //       throw e
  //     } else {
  //       const res = await e.res.json();
  //       throw { ...res, isServiceException: true }
  //     }
  //   })

  const { criteria, field } = sort;
  try {
    const url = `/delivery-service/coupon/suppliers?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "ASC"}&orderField=${field || "businessName"}&enabled=true${raffleId ? `&raffleId=${raffleId}` : ""}${filters.razonSocial ? `&razonSocial=${filters.razonSocial}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgenciesByStockItem EP: ", error);
    throw error;
  }
};

const getAgenciesByStockItem = async (
  page,
  pageSize,
  raffleId,
  filters,
  sort,
) => {
  const { criteria, field } = sort;
  try {
    const noaId = getNoaId();
    const url = `/delivery-service/agencies/byStock?organizationId=${noaId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "ASC"}&orderField=${field || "name"}&enabled=true${raffleId ? `&raffleId=${raffleId}` : ""}${filters.number ? `&number=${filters.number}` : ""}${filters.subnumber ? `&subNumber=${filters.subnumber}` : ""}${filters.name ? `&query=${filters.name}` : ""}`;
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgenciesByStockItem EP: ", error);
    throw error;
  }
};

const getAgencies = async (page, pageSize, sort) => {
  const { criteria, field } = sort;
  try {
    const noaId = getNoaId();
    const response = await apiClient.get(
      `/delivery-service/agencies?organizationId=${noaId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "ASC"}&orderField=${field || "name"}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgencies", error);
    throw error;
  }
};

const getAgencyById = async (agencyId) => {
  try {
    const response = await apiClient.get(
      `/delivery-service/agencies/${agencyId}`,
    );
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAgencyById EP ", error);
    throw error;
  }
};

const couponsService = {
  getAllCupons,
  getCuponsByGame,
  getPackagesByGame,
  getItemsByGameSerie,
  getMovements,
  getStockByGame,
  getLotteryStockItems,
  getAgenciesByStockItem,
  getSuppliersByStockItem,
  getAgencies,
  getAgencyById,
};

export default couponsService;
